<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { MobileDefaultTheme, DesktopDefaultTheme } from ".";

const { t } = useI18n();

const props = defineProps<{
  menuActive: string;
  accountStatus: string;
}>();

const menuList = computed(() => {
  if (props.accountStatus === "ACTIVE") {
    return [
      {
        key: "accounts",
        icon: "change",
        label: t("common.labels.change_account"),
        url: "/accounts",
      },
      {
        key: "signs",
        icon: "card-2",
        label: t("common.labels.signs"),
        url: "/signs",
      },
    ];
  }

  return [
    {
      key: "accounts",
      icon: "change",
      label: t("common.labels.change_account"),
      url: "/accounts",
    },
    {
      key: "plans",
      icon: "plans",
      label: t("common.labels.plans"),
      url: "/plans",
    },
  ];
});
</script>

<template>
  <template v-if="$store.getters.mobile">
    <mobile-default-theme :menu-list="menuList">
      <template #main>
        <slot></slot>
      </template>
    </mobile-default-theme>
  </template>
  <template v-else>
    <desktop-default-theme :menu-list="menuList" :menu-active="menuActive">
      <template #main>
        <slot></slot>
      </template>
    </desktop-default-theme>
  </template>
</template>

<style lang="scss" scoped>
.screen {
  display: grid;
  width: 100%;
  height: 100dvh;
  grid-template-columns: auto 1fr;

  .pages {
    display: flex;
    flex-direction: column;

    main {
      display: flex;
      flex-direction: column;
      padding-block-start: 1.57rem;
      padding-inline: 1.57rem;
      height: calc(100dvh - 80px - 1.57rem);
      overflow-y: auto;
    }
  }
}
</style>
